const FETCH_PROFILES_REQUEST = "FETCH_PROFILE_REQUEST"
const FETCH_PROFILES_SUCCESS = "FETCH_PROFILE_SUCCESS"
const FETCH_PROFILES_ERROR = "FETCH_PROFILE_ERROR"

export default {
 FETCH_PROFILES_REQUEST,
 FETCH_PROFILES_SUCCESS,
 FETCH_PROFILES_ERROR,
};
